module.exports = __webpack_public_path__ + "static/img/news1.31359a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news1.jpg
// module id = UdKi
// module chunks = 1